var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusiconblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147",
    transform: "translate(-406 -588.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_152_3",
    "data-name": "Component 152 \\u2013 3",
    transform: "translate(406 588.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-plus-869752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M86.52,9.519a7,7,0,1,0,7,7,7,7,0,0,0-7-7Zm3.464,7.406H86.824v3.159a.391.391,0,1,1-.783,0V16.925H82.9a.391.391,0,1,1,0-.783h3.159V12.983a.391.391,0,1,1,.783,0v3.159H90a.39.39,0,0,1,.391.391.412.412,0,0,1-.406.391Z",
    transform: "translate(-79.52 -9.519)",
    fill: "#4eb6ee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-pop-up-2186785",
    transform: "translate(2.742 3.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    "data-name": "Path 8886",
    d: "M311.14,50.213H308.3V47.375a.71.71,0,0,0-1.419,0v2.838h-2.838a.71.71,0,0,0,0,1.419h2.838v2.838a.71.71,0,0,0,1.419,0V51.632h2.838a.71.71,0,0,0,0-1.419Z",
    transform: "translate(-303.335 -46.665)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusiconblue);
export default __webpack_public_path__ + "static/media/plusiconblue.4058dd9ab6c7fb332b6b6c701f132ce6.svg";
export { ForwardRef as ReactComponent };